import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/product-palomino")({
  component: () => <Outlet />,
});
